export default "__VITE_ASSET__BPLj1R_J__"